<div class="grid-scroll-container" #gridContainer id="datagrid_div_container" [attr.aria-label]="customAriaLabel"
    role="region">
    <dx-data-grid id="datagrid_grid_main" (onEditorPrepared)="onEditorPrepared($event)"
        [dataSource]="data && data.length > 0 ? data : (applicationData && applicationData.length ? applicationData : [])"
        [showBorders]="true" [width]="'100%'" [columnAutoWidth]="true" [allowColumnResizing]="true"
        [columnResizingMode]="'widget'" [rowAlternationEnabled]="true" [paging]="{ enabled: showPaging }"
        [scrolling]="{ mode: 'standard', showScrollbar: 'onHover', useNative: true }" [noDataText]="customNoDataText"
        class="devextreme-table table-border" (onPageChanged)="onPageChanged($event)"
        [editing]="{ mode: 'cell', allowUpdating: true }" class="devextreme-table table-border"
        (onOptionChanged)="onGridOptionChanged($event)">
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-filter-row id="datagrid_filter_row" [visible]="showSearchRow && hasData()"
            [applyFilter]="'auto'"></dxo-filter-row>
        <dxo-header-filter id="datagrid_filter_header" [visible]="showFiltering"></dxo-header-filter>
        <dxo-paging id="datagrid_paging_controls" [pageSize]="customPageSize" *ngIf="showPaging"></dxo-paging>
        <ng-container *ngFor="let data of (customHeaders.length > 0 ? customHeaders : headers)">
            <dxo-header-filter [visible]="data.allowFiltering"></dxo-header-filter>
            <dxi-column *ngIf="!visibleColumns || visibleColumns[data.dataField] !== false" [dataField]="data.dataField"
                [caption]="data.caption" [allowFiltering]="data.allowFiltering"
                [allowSearch]="data.allowSearch.isSearchEnable"
                [dataType]="isDateField(data.dataField) ? 'date' : data.allowSearch.type"
                [format]="onEditorPrepared(data.dataField) ? 'MM/dd/yyyy' : undefined"
                [calculateCellValue]="data.dataField === 'application_status' ? calculateStatusCellValue : (data.dataField === 'application_type' ? calculateTypeCellValue : (data.dataField === 'locked_by' || data.dataField === 'Locked_by' ? calculateLockedByCellValue :  undefined))"
                [editorOptions]="data.editorOptions"
                [headerCellTemplate] = "data.dataField === 'Value' ? 'valueHeaderTemplate' : null"
                    [allowEditing]="['Value','queuesvalue','securityvalue','registrationvalue'].includes(data.dataField)"
                    [editCellTemplate]="
      data.dataField === 'Value' ? 'valueCellTemplate' :
      data.dataField === 'queuesvalue' ? 'queuesValueCellTemplate' :
      data.dataField === 'securityvalue' ? 'securityValueCellTemplate' :
      data.dataField === 'registrationvalue' ? 'registrationValueCellTemplate' :
      undefined"
                    [cellTemplate]="
      data.dataField === 'Value' ? 'valueCellTemplate' :
      data.dataField === 'Value' ? 'queuesValueCellTemplate' :
      data.dataField === 'securityvalue' ? 'securityValueCellTemplate' :
      data.dataField === 'registrationvalue' ? 'registrationValueCellTemplate' :
      undefined"> <dxo-header-filter [visible]="data.allowFiltering"></dxo-header-filter>
                <dxi-validation-rule
                    *ngIf="['Value', 'queuesvalue', 'securityvalue', 'registrationvalue'].includes(data.dataField)"
                    type="required" message="Please enter a value."></dxi-validation-rule>
                <dxi-validation-rule
                    *ngIf="['Value', 'queuesvalue', 'securityvalue', 'registrationvalue'].includes(data.dataField)"
                    type="numeric" message="Value must be a number."></dxi-validation-rule>
            </dxi-column>
        </ng-container>
        <div *dxTemplate="let header of 'valueHeaderTemplate' ">
            <span>
                {{header.column.caption}}
                <span style="color:red !important; font-weight:bold;">*</span>
            </span>
        </div>

        <div *dxTemplate="let cell of 'valueCellTemplate'" class="value-input-wrapper">
            <input numbersOnly class="value-cell-input input_value text-center" placeholder="Enter Value" [value]="cell.data.Value"
               [attr.data-row-key]="cell.data.strRuleName || cell.data.intBusinessRuleId || cell.rowIndex"
               (keyup)="onValueInputChange(cell, $event)" (blur)="onValueInputChange(cell, $event)" (change)="onValueInputChange(cell, $event)"
               (keydown.enter)="onValueInputChange(cell, $event)" />
            <div *ngIf="cell.data.apiError" class="text-danger small mt-1">{{ cell.data.apiError }}</div>
            <div *ngIf="!cell.data.apiError && (cell.data.valueError || cell.data.Value === undefined || cell.data.Value === null || cell.data.Value === '')" class="text-danger small mt-1">Please enter a value.</div>
            </div>
        <dxi-column *ngIf="showActionsColumn" caption="Action" cellTemplate="cellTemplate" [fixed]="!isMobileView" [fixedPosition]="!isMobileView ? 'right' : undefined"width="150" [allowFiltering]="false" [allowSearch]="false">
            <div *dxTemplate="let cell of 'cellTemplate'; let index = index" id="datagrid_template_actions">
                <ng-container *ngIf="projectedActionsTemplate || actionsTemplateRef; else defaultActions">
                    <ng-container *ngTemplateOutlet="projectedActionsTemplate || actionsTemplateRef; context: { $implicit: cell.data, index: index }"></ng-container>
                </ng-container>
                <ng-template #defaultActions>
                    <div class="action-buttons-container action-only"
                        [id]="'datagrid_div_actions_' + cell.data.application_id">
                        <button type="button" class="action-icon-button" matTooltip="Reset"
                            matTooltipPosition="above" (mousedown)="$event.preventDefault(); onResetRow(cell.data)">
                            <img src="assets/images/reset.svg" alt="Reset" width="20" height="20" />
                        </button>
                        <button type="button" class="action-icon-button" matTooltip="Save"
                            matTooltipPosition="above" (click)="$event.preventDefault(); onSaveRow(cell.data)"
                            [disabled]="cell.data.Value === undefined || cell.data.Value === '' || cell.data.valueError === true">
                            <img src="assets/images/save.svg" alt="Save" width="20" height="20" />
                        </button>
                    </div>
                </ng-template>
            </div>
        </dxi-column>

        <dxo-pager id="datagrid_paging_controls" [visible]="showPaging" [allowedPageSizes]="customPageSizes"
            [showPageSizeSelector]="true" [showNavigationButtons]="true" [showInfo]="true" [displayMode]="'compact'"
            [infoText]="customInfoText" *ngIf="showPaging">
        </dxo-pager>
    </dx-data-grid>
</div>